/**
 * @generated SignedSource<<0cc626a9610f5e90586dc007df7abcaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type fileUploadQuery$variables = {
  id: string;
};
export type fileUploadQuery$data = {
  readonly user__FileUploads__getFileUpload: {
    readonly id: string;
    readonly url: string;
  };
};
export type fileUploadQuery = {
  response: fileUploadQuery$data;
  variables: fileUploadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "FileUpload",
    "kind": "LinkedField",
    "name": "user__FileUploads__getFileUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fileUploadQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fileUploadQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b9a15d03485215fc8230d70aabed0d9b",
    "id": null,
    "metadata": {},
    "name": "fileUploadQuery",
    "operationKind": "query",
    "text": "query fileUploadQuery(\n  $id: ID!\n) {\n  user__FileUploads__getFileUpload(id: $id) {\n    id\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "1271d88c8e407295ee1c58705699a4f1";

export default node;
